module.exports = __webpack_public_path__ + "static/media/realtors-icon-9.2c1897b2.svg";